export default class ChangelogService {
  constructor($rootScope, $http, $q, UIService, Authorization) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.Authorization = Authorization;
    this.UI = UIService;
    this.data = [];
    this.status = $rootScope.status;
    this.appsOK = true;
    this.$http = $http;
  }

  loadData = () => {
    let defer = this.$q.defer();
    let apiQuery = {
      order: "version DESC"
    };

    this.$http.get('https://cc.streamline.pt/api/applications/697a4154323778001225c123/versions?filter=' + JSON.stringify(apiQuery)).then((res) => {
      if (res.data === null) {
        defer.reject("Error");
      }

      res.data.forEach(r => {

        let parts = r.version.match(/.{1,3}/g) || [];
        parts = parts.map((r) => Number(r));
        r.string =`${parts[0]}.${parts[1]}.${parts[2]}`;
      });
      this.data = res.data;
      defer.resolve(res.data);
    }).catch(err => {
      defer.reject(err);
    });
    return defer.promise;
  };

  // Get specific version, or the most recent if undefined
  getVersion = (version) => {
    let found = null;

    let defer = this.$q.defer();
    this.loadData().then((res) => {
      if (angular.isUndefined(version)) {
        found = res[0];
      } else {
        found = res.find(r => r.version.localeCompare(version) === 0);
      }
      defer.resolve(found);
    });

    return defer.promise;
  };

  getVersions = () => {
    let defer = this.$q.defer();
    this.loadData().then(r => defer.resolve(r)).catch(err => defer.reject(err));
    return defer.promise;
  };

  getReleaseNote = (from, to) => {
    let defer = this.$q.defer();
    // TODO - Changelog File URL with 'from' and 'to'
    let url = ``;
    defer.resolve(url);
    return defer.promise;

  }
}

ChangelogService.$inject = ['$rootScope', '$http', '$q', 'UIService', 'AuthorizationService'];
